// Copyright 2022 Lexoh Inc. All rights reserved.
// NOTICE: All information contained herein is, and remains the property of
// Lexoh Inc. The intellectual and technical concepts contained herein are
// proprietary to Lexoh Inc and may be covered by Canada and Foreign Patents, patents
// in process, and are protected by trade secret or copyright law. Dissemination
// of this information or reproduction of this material is strictly forbidden
// unless prior written permission is obtained from Lexoh Inc. Access to the source
// code contained herein is hereby forbidden to anyone except current Lexoh Inc
// employees, managers or contractors who have executed Confidentiality and
// Non-disclosure agreements explicitly covering such access.
const WS_URL = process.env.NODE_ENV == 'development' ? 'wss://' + window.location.hostname + ':4001/' : 'wss://' + window.location.hostname + ':4001/';
// const WS_URL = 'wss://demo.app.lexoh.com:3001/';

class SocketService
{
	initialize(app)
	{
		let has_connected = false;
		//@ts-ignore
		SocketService.Socket = new WebSocket(WS_URL);
		//@ts-ignore
		SocketService.Socket.onopen = function()
		{
			try
			{
				has_connected = true;
				console.log('CONNECTED');
				//@ts-ignore
				this.send(JSON.stringify({
					'Action': 'Authenticate',
					'Token': localStorage.getItem('token')
				}));
			}
			catch(error)
			{
				console.error(error);
			}
		};
		//@ts-ignore
		SocketService.Socket.onmessage = function (evt) {
			try
			{
				const json = JSON.parse(evt.data);
				switch(json.Action)
				{
					case 'ChangeState':
					{
						app.$eventBus.emit('device_state_changed', json);
					}
					break;
				}
			}
			catch(error)
			{
				console.error(error);
			}
		};
		//@ts-ignore
		SocketService.Socket.onclose = function() {
			if (has_connected) {
				window.location.href = '/';
			}
		};
	}

	send(data: string)
	{
		//@ts-ignore
		SocketService.Socket.send(data);
	}
}

export default SocketService;
